import { useQuery } from '@tanstack/react-query';

// import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface CalculateDiscountByEntityParams {
  studentId: string;
  entityType: 'enrollment';
  entityId: string;
}

export const calculateDiscountByEntityAPI = async (
  params: CalculateDiscountByEntityParams,
) => {
  const resp = await baseAPI.get<{ totalDiscount: number }>(
    '/discount/calculate-by-entity',
    {
      params,
    },
  );
  return resp.data;
};

export const useGetCalculateDiscountByEntity = (
  params: CalculateDiscountByEntityParams,
) => {
  return useQuery({
    queryKey: [KEYS.DISCOUNT_BY_ENTITY, params],
    queryFn: () => calculateDiscountByEntityAPI(params),
    enabled: !!params.studentId && !!params.entityId,
  });
};
